import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import {CouponsProvider} from "../../contexts/couponContext/CouponContext";

const CouponFragment = Loadable(lazy(() => import('./views/CouponFragment')));
const AddCouponFragment = Loadable(lazy(() => import('./views/AddCouponFragment')));

const couponsRoutes = [
    { path: '/coupons', element: <CouponsProvider><CouponFragment /></CouponsProvider> },
    { path: '/add_coupon', element: <CouponsProvider><AddCouponFragment /></CouponsProvider> },
    { path: '/edit_coupon/:id', element: <CouponsProvider><AddCouponFragment /></CouponsProvider> },
    { path: '/view_coupon/:id', element: <CouponsProvider><AddCouponFragment preview/></CouponsProvider> },
];

export default couponsRoutes;
